<div class="alert">
  @if (showIcon()) {
    <div class="alert-icon">
      <mat-icon [svgIcon]="this.svgIcon() ?? ''">
        {{ this.currentIcon }}
      </mat-icon>
    </div>
  }

  <div class="text">
    <ng-content />
  </div>

  @if (showAction()) {
    <div [ngClass]="stackedView() ? 'hide-object' : 'action'" [class.beside-close-button]="showClose()">
      <ng-container [ngTemplateOutlet]="actionButton" />
    </div>
  }

  @if (showClose()) {
    <div [ngClass]="stackedView() ? 'hide-object' : 'close-button'" [class.beside-action-button]="showAction()">
      <button mat-icon-button (click)="this.close.emit()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</div>

<div class="alert-extended-wrapper">
  <ng-content select="glxy-alert-extended" />
</div>

@if (showAction()) {
  <div [ngClass]="stackedView() ? 'show-object' : 'mobile-action'" class="mobile-button-wrapper">
    <ng-container [ngTemplateOutlet]="actionButton" />
  </div>
}

@if (showClose()) {
  <div [ngClass]="stackedView() ? 'show-object' : 'mobile-close-button'" class="mobile-button-wrapper">
    <button mat-stroked-button (click)="this.close.emit()">
      {{ this.closeTitle() }}
    </button>
  </div>
}

<ng-template #actionButton>
  @if (actionExternalLink()) {
    <a
      [href]="actionExternalLink()"
      [matButton]="actionButtonType()"
      (click)="this.actionClick.emit()"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ this.actionTitle() }}
    </a>
  } @else {
    <button
      [routerLink]="actionRouterLink()"
      [matButton]="actionButtonType()"
      type="button"
      (click)="this.actionClick.emit()"
    >
      {{ this.actionTitle() }}
    </button>
  }
</ng-template>
